function toSentenceCase(str?: string) {
    if (!str) return undefined;
    const firstChar = str.charAt(0).toUpperCase();
    const restOfString = str.slice(1).toLowerCase();
    return firstChar + restOfString;
}

export function getFormattedIntent({ device, intent }: { device?: string; intent?: string }) {
    return toSentenceCase(device && intent ? `${device} ${intent}` : (device ?? intent));
}
